import _ from 'lodash'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PackageSelection from './PackageSelection'
import FamilyMemberSelection from './FamilyMemberSelection'
import { Col, Container, Row } from 'reactstrap'

const ProgramDetailsStep = () => {
  const { t } = useTranslation()
  const enrollmentData = useSelector(state => state.programRegistration.enrollmentData)

  const withPackages = !_.isEmpty(enrollmentData.coursePackages)

  return (
    <Container fluid id='ProgramDetailsStep'>
      <h2 className='d-none d-lg-block step-title'>{t('programs.registration.detailsStep.title')}</h2>
      <Row>
        <Col sm={6}>
          <FamilyMemberSelection />
        </Col>
      </Row>
      {withPackages && (
        <Row>
          <Col className='pt-5'>
            <PackageSelection />
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default ProgramDetailsStep
